import { render, staticRenderFns, recyclableRender, components } from "./u-loading-icon.vue?vue&type=template&id=0fe228ae&scoped=true&"
var renderjs
import script from "./u-loading-icon.vue?vue&type=script&lang=js&"
export * from "./u-loading-icon.vue?vue&type=script&lang=js&"
import style0 from "./u-loading-icon.vue?vue&type=style&index=0&id=0fe228ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe228ae",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-loading-icon/u-loading-icon.vue"
export default component.exports